const MINUTES = 60;
const MILLISECONDS = 1000;
export default function setCookie(name: string, value: any, minutes: number) {
    let expires = '';
    if (minutes) {
        const date = new Date();
        date.setTime(date.getTime() + minutes * MINUTES * MILLISECONDS);
        expires = '; expires=' + date.toUTCString();
    }
    const valueString = JSON.stringify(value);

    document.cookie =
        name + '=' + encodeURIComponent(valueString) + expires + '; path=/';
}
